module.exports = __webpack_public_path__ + "img/16.90e122ef.jpg";